import * as React from 'react'
import { FaIcon, faChevronsLeftSolid, faChevronsRightSolid } from '@/lib/fa'
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons'
import moment from 'moment'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
const MonthlyNavigation = ({
  goToDate,
  currentDate,
}: {
  goToDate: ({ weeks }: { weeks: number }) => void
  currentDate: string
}) => {
  const { t } = useLocalize()
  const formattedDate = React.useMemo(() => {
    if (!currentDate) return ''
    const date = moment(currentDate, 'YYYY-MM')
    return `${date.format('YYYY')} - ${t(`monthName.${date.format('MMMM')?.toLocaleLowerCase()}`)}`
  }, [currentDate, t])

  return (
    <div className="tw-sticky tw-top-0 tw-flex tw-items-center tw-justify-between tw-bg-white tw-px-5 tw-py-3">
      <div className="tw-flex tw-items-center tw-gap-1">
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate({ weeks: -2 })}
        >
          <FaIcon icon={faChevronsLeftSolid} className="tw-h-[10px]" />
        </div>
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate({ weeks: -1 })}
        >
          <FaIcon icon={faChevronLeft} className="tw-h-[10px]" />
        </div>
        <p className="tw-px-2 tw-text-base tw-font-semibold tw-text-content-base">
          {formattedDate}
        </p>
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate({ weeks: 1 })}
        >
          <FaIcon icon={faChevronRight} className="tw-h-[10px]" />
        </div>
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate({ weeks: 2 })}
        >
          <FaIcon icon={faChevronsRightSolid} className="tw-h-[10px]" />
        </div>
      </div>
    </div>
  )
}

export default MonthlyNavigation
